import { render, staticRenderFns } from "./ProductInfoFieldColumnMenu.vue?vue&type=template&id=f78d0562&"
import script from "./ProductInfoFieldColumnMenu.vue?vue&type=script&lang=js&"
export * from "./ProductInfoFieldColumnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports